import { classes } from "@theme/helpers";
import { HTMLCustomElement } from "@theme/html-custom-element";

class ProductGallery extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    if (this.refs.swiper) {
      new Swiper(this.refs.swiper, {
        navigation: {
          nextEl: this.refs.next,
          prevEl: this.refs.prev,
        },
        loop: true,
        pagination: {
          el: this.refs.pagination,
          type: "fraction",
        },
        scrollbar: {
          el: this.refs.scrollbar,
        },
      });
    }
  }
}

if (!customElements.get("product-gallery"))
  customElements.define("product-gallery", ProductGallery);
